<template>
  <v-alert
    class="action d-flex justify-center"
    dense
    :type="type"
    height="max-content"
    icon="mdi-information-outline"
    :color="color"
    :text="text"
  >
    {{ message }}

    <slot />
  </v-alert>
</template>

<script>
export default {
  name: 'BaseMessage',
  props: {
    message: {
      type: String,
      default: ''
    },
    /**
     * info, success, warning, error
     */
    type: {
      type: String,
      required: true
    },
    color: {
      type: String,
      default: ''
    },
    text: {
      type: Boolean,
      default: false
    }
  }
}
</script>
<style scoped>
.v-alert:not(.v-sheet--tile) {
  border-radius: 35px;
}

.v-alert >>> i {
  margin: auto;
  padding-right: 8px;
}
</style>
